<script>
  import Produto from '../../models/Produto';

  export let banner;

  $: id = banner.id;
  $: titulo = banner.titulo;
  $: ativo = banner.ativo;
</script>

<tr>
  <td>
    <a href="/#/painel/espacos/{id}">
      {titulo}
    </a>
  </td>
  <td>{ativo}</td>
  <td>
    <a href="/#/painel/espacos/{id}">
      Editar
    </a>
  </td>
</tr>